<template>
  <m-a :href="{name:editRoutes[this.itemType],params:{...routerParams}}" v-if="isAdmin">
    <m-icon icon="pencil"/>
  </m-a>
</template>

<script>
/*
* this component can be use on product, any content(post, page and lesson) and course to
* redirect user to edit mode of that item in dashboard.
*
* */
import {mapGetters} from "vuex";
import {findRoutes} from '@moeinmdn/mixitweb-front-classic-dashboard/src/plugin/routes/RouterFunctions'
import {dashboardRoutes} from '@moeinmdn/mixitweb-front-classic-dashboard/src/plugin/routes/DashboardRoutes'

export default {
  name: "EditItem",
  props: {
    itemType: {
      default: 'product' // supported types product, post, page, lesson and course
    },
    itemParams: {
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      editRoutes: {
        'product': 'EditProduct',
        'post': 'PostsDashboard',
        'page': 'page',
        'lesson': 'lesson',
        'course': 'course',
      }
    }
  },
  computed: {
    ...mapGetters({
      'isAdmin': 'User/isAdmin'
    }),
    routerParams() {

      const dashboardRoute = this.findRoutes(dashboardRoutes, [this.editRoutes[this.itemType]])[0];
      let params = {};
      let counter = 0;

      dashboardRoute.path.split('/').forEach(item => {
        if (item.indexOf(':') > -1) {
          params[item.replace(':', '')] = this.itemParams[counter]
          counter += 1
        }
      })
      return params


    }
  },
  methods: {
    findRoutes,
  }
}
</script>

<style scoped>

</style>